export const removeUrlQueryStringAndFragment = (url?: string) => {
  if (!url) {
    return url
  }

  const { origin, pathname } = new URL(url)
  return origin + pathname
}
